import { render } from "./PanelBlockSelectedItems.vue?vue&type=template&id=7c4bb678&scoped=true"
import script from "./PanelBlockSelectedItems.vue?vue&type=script&lang=js"
export * from "./PanelBlockSelectedItems.vue?vue&type=script&lang=js"

import "./PanelBlockSelectedItems.vue?vue&type=style&index=0&id=7c4bb678&lang=scss&scoped=true"

import exportComponent from "/builds/smartcom-gitlab-cis/maap/Application/Frontends/ProSpace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c4bb678"]])

export default __exports__